import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MapColoursService} from '@core/utils/engin/geospatial-viewer/renderers/map-colours.service';
import {ViewCell} from '@mominsamir/ngx-smart-table';
import {NbThemeService} from '@nebular/theme';
import {GeospatialColourType} from '../../../../../../pages/geospatial-viewer/model/spatial-colours';

@Component({
    selector: 'ngx-colored-metric-cell',
    template: `
        <div *ngIf="value">
            <span class="legend-color" [ngStyle]="getBackgroundColor(value)"></span>
            {{ label(value) }}
        </div>
    `,
    styleUrls: ['./colored-metric-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColoredMetricCellComponent implements ViewCell {
    constructor(private nbThemeService: NbThemeService) {}
    @Input() value: any;
    @Input() rowData: any;

    label = (value: string) => '';

    public getBackgroundColor(value: string): any {
        const color = MapColoursService.getMapCategoryColour(value, this.nbThemeService.currentTheme)?.color;
        return {'background-color': color, 'border-color': color};
    }
}
